export function validarCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, "");
  let tempCpf = String(cpf);
  if (tempCpf === "") return false;
  // Elimina CPFs invalidos conhecidos
  if (
    tempCpf.length !== 11 ||
    tempCpf === "00000000000" ||
    tempCpf === "11111111111" ||
    tempCpf === "22222222222" ||
    tempCpf === "33333333333" ||
    tempCpf === "44444444444" ||
    tempCpf === "55555555555" ||
    tempCpf === "66666666666" ||
    tempCpf === "77777777777" ||
    tempCpf === "88888888888" ||
    tempCpf === "99999999999"
  )
    return false;
  // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(tempCpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(tempCpf.charAt(9))) return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(tempCpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(tempCpf.charAt(10))) return false;
  return true;
}
